import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../context/AppContext';
import { getCompanies } from '../services/adminServices';
import moment from 'moment';
import { Link } from "react-router-dom"

export const AdminCompanies = () => {
  const { login } = useContext(AppContext);
  const [filter, setFilter] = useState({ name: "", limit: 5, page: 1 });
  const [pagination, setPagination] = useState({});
  const [companies, setCompanies] = useState([]);

  const getAllCompanies = async (filters = filter) => {
    try {
      let result = await getCompanies(login.token, filters);
      setPagination(result.pagination)
      setCompanies(result.data.map((x) => ({ ...x, isGroup: false })));
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleNext = () => {
    if (pagination.currentPage < pagination.totalPages) {
      const newPage = pagination.currentPage + 1;
      setFilter({ ...filter, page: newPage });
      getAllCompanies({ ...filter, page: newPage });
    }
  };

  const handlePrev = () => {
    if (pagination.currentPage > 1) {
      const newPage = pagination.currentPage - 1;
      setFilter({ ...filter, page: newPage });
      getAllCompanies({ ...filter, page: newPage });
    }
  };

  useEffect(() => {
    setCompanies([]);
    getAllCompanies();
  }, []);

  return (
    <div className="details-table mt-3">
      <div className="search-container mb-3">
        <h4>
          <i class="fas fa-building"></i>
          Companies Details :
        </h4>
        <div className="headerWrap">
          <form onSubmit={(e) => {
            e.preventDefault();
            getAllCompanies();
          }} className="d-flex">
            <button type="submit" id="searchButton" style={{ background: "none", border: "none", padding: 0 }}>
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.5 21.5C16.7467 21.5 21 17.2467 21 12C21 6.75329 16.7467 2.5 11.5 2.5C6.25329 2.5 2 6.75329 2 12C2 17.2467 6.25329 21.5 11.5 21.5Z" stroke="#657488" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M22 22.5L20 20.5" stroke="#657488" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
              </svg>
            </button>
            <input
              className="fs-18 tableSearch"
              type="text"
              value={filter.name}
              onChange={(e) => setFilter({ ...filter, name: e.target.value })}
              id="searchInput"
              name="search"
              placeholder="Search here . . ."
            />
          </form>
        </div>
      </div>
      <table id="example" className="display" style={{ "width": "100%" }}>
        <thead>
          <tr>
            <th>No</th>
            <th>Name</th>
            <th>Email Id</th>
            <th>Domain</th>
            <th>Mobile</th>
            <th>Expiring At</th>
            <th>Plan Type</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {
            companies.map((x, i) => {
              return (
                <tr key={x._id}>
                  <td>{((pagination.currentPage - 1) * filter.limit) + (i + 1)}</td>
                  <td>{x.name}</td>
                  <td>{x.email}</td>
                  <td>{x.domain}</td>
                  <td>(+91){x.phone}</td>
                  <td>{x.appExpiringAt ? moment(x.appExpiringAt).format("DD MMM YYYY") : "Not Added"}</td>
                  <td>{x.appPlanType}</td>
                  <td>
                    <div className="export-chat edit-delete-user">
                      <Link to={`/${x._id}/details`}>
                        <i className="fa fa-eye" aria-hidden="true"></i>
                      </Link>
                    </div>
                  </td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
      <div className="custom-pagination">
        <span className="showing-entries">Showing {(pagination.currentPage - 1) * filter.limit + 1} - {Math.min((pagination.currentPage) * filter.limit, pagination.totalDocuments)} of {pagination.totalDocuments}</span>
        <div className="page-controls">
          <button
            className="page-btn prev"
            onClick={handlePrev}
            disabled={pagination.currentPage === 1} // Disable button on first page
          >
            <i className="fas fa-chevron-left"></i>
          </button>
          <span className="current-page">{pagination.currentPage}</span>
          <span className="separator">/</span>
          <span className="total-pages">{pagination.totalPages}</span>
          <button
            className="page-btn next"
            onClick={handleNext}
            disabled={pagination.currentPage === pagination.totalPages} // Disable button on last page
          >
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  )
}
